import { Reveal } from "./Reveal";

const PORTRAIT = "/sean-bledsoe-portrait.png";

export const Biography = () => {
  return (
    <section
      id="about"
      data-testid="biography-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <img
              src={PORTRAIT}
              alt="Sean Bledsoe, executive portrait"
              className="w-full h-[560px] lg:h-[680px] object-cover grayscale-[12%]"
              loading="lazy"
            />
            <div className="absolute -bottom-6 -right-6 bg-[#0A192F] text-white p-6 max-w-xs hidden md:block">
              <div className="text-xs uppercase tracking-[0.3em] text-white/60 mb-2">
                Currently
              </div>
              <div className="font-serif text-xl leading-tight">
                CEO & President,
                <br />
                Healthy Plus · DigiDoc
              </div>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
                Biography
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
              From the sideline
              <br />
              to the operating layer
              <br />
              of healthcare.
            </h2>
          </Reveal>

          <Reveal delay={140} className="mt-10 space-y-6 max-w-2xl text-[#475569] text-lg leading-relaxed">
            <p>
              Sean Bledsoe is the CEO and President of Healthy Plus and the
              founder of DigiDoc — the digital health ecosystem connecting
              preventive care to back-end care management for patients, doctors,
              and insurance carriers. Healthy Plus is the "GAP" company built to
              re-shape the culture of prevention through an e-health platform.
            </p>
            <p>
              Under Sean's leadership, Healthy Plus integrated with{" "}
              <strong className="text-[#0A192F]">athenahealth's</strong> growing
              provider network, was named a{" "}
              <strong className="text-[#0A192F]">
                Top 10 Entrepreneur to Watch (2020)
              </strong>{" "}
              by Industry Tech Outlook, and earned{" "}
              <strong className="text-[#0A192F]">
                Top Vendor honors from Shortlister (Q4 2020)
              </strong>{" "}
              in Health Risk Assessment. He founded Healthy Plus India Pvt. Ltd.
              to extend DigiDoc globally under DPDP standards.
            </p>
            <p>
              Before healthcare, Sean spent two decades on the hardwood. He
              became the youngest head college basketball coach in the country
              at <strong className="text-[#0A192F]">age 24</strong>, with
              assistant coaching tenures at Urbana University, Indiana State,
              Bowling Green, Cleveland State, and UMKC. He is also the founder
              of <strong className="text-[#0A192F]">Bledsoe Basketball
              Academy (BBA)</strong> — channeling that coaching legacy into the
              next generation of athletes.
            </p>
          </Reveal>

          <Reveal delay={260} className="mt-12 grid sm:grid-cols-3 gap-6">
            {[
              { k: "Current Role", v: "CEO · Healthy Plus" },
              { k: "Based", v: "United States · India" },
              { k: "Recognized", v: "Top 10 Entrepreneur 2020" },
            ].map((row) => (
              <div key={row.k} className="border-t border-[#0A192F]/15 pt-4">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/60">
                  {row.k}
                </div>
                <div className="mt-2 text-[#0A192F]">{row.v}</div>
              </div>
            ))}
          </Reveal>
        </div>
      </div>
    </section>
  );
};
